// api/v1/retails/dashboard

import Http from '../http'

export default {
  indexRetailDashborad(filter){
    let {form_id, solution_id, time_group, start_date, end_date, kind, department_ids} = filter
    kind = kind || 'dashboard'
    return Http.post(`/retail/${kind}`,{
      //...filter
      solution_id,
      department_ids,
      time_group,
      start_date,
      end_date,
    })
  },

  departmentScoreEvolution(filter){
    let {form_id, solution_id, time_group, start_date, end_date, department_id} = filter
    return Http.get(`/reports/score_evolution/`,{
      params:
      // JSON.stringify(
        {
          //...filter
          solution_id,
          department_id,
          time_group,
          start_date,
          end_date,
        }
      // )
    })
  },

  departmentsRanking(filter){
    let {solution_id, time_group, start_date, end_date, department_id} = filter
    return Http.get(`/reports/department_ranking/`,{
      params:
      // JSON.stringify(
        {
          //...filter
          solution_id,
          department_id,
          time_group,
          start_date,
          end_date,
        }
      // )
    })
  },

}